// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"0055db0d","359":"bd3f7b7f"}[chunkId] + ".chunk.js";
};